import { getDefaultExportFromCjs } from '../../../_virtual/_commonjsHelpers.js';
import { __exports as lib } from '../../../_virtual/index3.js';
import './slider.js';
import { __exports as slider } from '../../../_virtual/slider.js';

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _slider = _interopRequireDefault(slider);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	var _default = _slider["default"];
	exports["default"] = _default; 
} (lib));

var Slider = /*@__PURE__*/getDefaultExportFromCjs(lib);

export { Slider as default };
